import { render, staticRenderFns } from "./LocalTime.vue?vue&type=template&id=ab8d8570"
import script from "./LocalTime.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocalTime.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports